'use client'
import '@szhsin/react-menu/dist/index.css'
import '@szhsin/react-menu/dist/transitions/slide.css'

import { ControlledMenu, MenuItem, SubMenu } from '@szhsin/react-menu'
import { useHover, useMenuState } from '@szhsin/react-menu'
import React, { FC, useRef } from 'react'

import Chevron from '@/components/svg/Chevron'
import { cn } from '@/lib/utils'

import { MenuItem as MenuItemType, NavigationItem } from '../../lib/navigationLinks'
import LinkWithQuery from '@/components/LinkWithQuery'

const DropdownMenu: FC<NavigationItem> = ({ label, path, menuItems }) => {
  const ref = useRef<HTMLDivElement>(null)
  const [menuState, toggle] = useMenuState({ transition: true })
  const { anchorProps, hoverProps } = useHover(menuState.state, toggle)

  const renderSubMenu = (item: MenuItemType) => (
    <SubMenu
      key={item.label}
      className="transition duration-100 ease-in text-white"
      menuClassName="!bg-black p-0 pt-2 rounded-none"
      label={
        <LinkWithQuery href={item.path} prefetch={false} className="flex items-center w-full">
          {item.label}
        </LinkWithQuery>
      }
    >
      {item.subMenuItems?.map((subMenuItem) => renderLink(subMenuItem))}
    </SubMenu>
  )

  const renderLink = (item: MenuItemType) =>
    item.external ? (
      <MenuItem
        className="p-4 text-white hover:!bg-red-torch hover:transition-100 hover:transition-all hover:duration-100 hover:ease-in"
        key={item.label}
        href={item.path}
        target="_blank"
        rel="noreferrer"
      >
        {item.label}
      </MenuItem>
    ) : (
      <LinkWithQuery href={item.path} key={item.label} prefetch={false}>
        <MenuItem className="p-4 text-white hover:!bg-red-torch hover:transition-all hover:duration-100 hover:ease-in">
          {item.label}
        </MenuItem>
      </LinkWithQuery>
    )

  return (
    <>
      <LinkWithQuery href={path} prefetch={false} className="m-0">
        <div
          ref={ref}
          {...anchorProps}
          className="text-white text-sm font-semibold flex gap-4 items-center cursor-pointer p-4"
        >
          {label}
          <Chevron direction="down" />
        </div>
      </LinkWithQuery>
      <ControlledMenu
        {...hoverProps}
        {...menuState}
        transition
        // @ts-expect-error it's fine
        anchorRef={ref}
        onClose={() => toggle(false)}
        menuClassName={({ state }) =>
          cn('!bg-black p-0 pt-2 rounded-none font-medium', {
            'animate-fadeIn': state === 'opening',
            'animate-fadeOut': state === 'closing',
          })
        }
      >
        {menuItems?.map((item) =>
          item.subMenuItems ? renderSubMenu(item) : renderLink(item),
        )}
      </ControlledMenu>
    </>
  )
}

export default DropdownMenu
